if (!customElements.get('adk-prize-slider')) {
  customElements.define('adk-prize-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.adk-prizes__grid');
      this.cards = [...this.querySelectorAll('.adk-prizes__card')];
      this.controls = this.querySelector('.adk-prizes__controls');
      this.dots = [...this.querySelectorAll('[data-prize-index]')];
      this.mobile = matchMedia('(max-width: 767px)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.go = index => {
        index = Math.max(0, Math.min(this.cards.length - 1, index));
        const left = this.cards[index].offsetLeft - this.cards[0].offsetLeft;
        this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.querySelector('[data-prize-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-prize-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (this.mobile.matches && index >= 0) this.go(index);
      }, options);
      this.mobile.addEventListener('change', () => this.update(), options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      this.controls.hidden = !this.mobile.matches || this.cards.length < 2;
      this.track.tabIndex = this.mobile.matches ? 0 : -1;
      const first = this.cards[0];
      if (!first) return;
      this.index = this.cards.reduce((best, card, index) =>
        Math.abs(card.offsetLeft - first.offsetLeft - this.track.scrollLeft) < Math.abs(this.cards[best].offsetLeft - first.offsetLeft - this.track.scrollLeft) ? index : best, 0);
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      this.querySelector('[data-prize-prev]').disabled = this.index === 0;
      this.querySelector('[data-prize-next]').disabled = this.index === this.cards.length - 1;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
